
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SideBarComp',
  data() {
    return {
      activeLink: 'dashboard' // Set the initial active link here
    };
  },
  created() {
    this.setActiveLink();
  },
  methods: {
    setActiveLink() {
      // Get the current URL
      const currentURL = window.location.href;

      // Check if the URL contains a specific string and set the active link accordingly
      if (currentURL.includes('register')) {
        this.activeLink = 'register';
      } else if (currentURL.includes('access')) {
        this.activeLink = 'access';
      } else if (currentURL.includes('controle')) {
        this.activeLink = 'controle';
      } else {
        this.activeLink = 'dashboard';
      }
    }
  }
});
